import { render, staticRenderFns } from "./convenio.vue?vue&type=template&id=18d96d24&"
import script from "./convenio.vue?vue&type=script&lang=js&"
export * from "./convenio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports